import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  requiredFieldsNote: {
    ...theme.typography.txtBody2,
    color: theme.colors.grey3,
    marginTop: 13
  },
  label: {
    ...theme.typography.txtBody2,
    fontFamily: "Inter, sans-serif",
    display: "inline-flex",
    margin: 0,
    marginBottom: 5
  },
  dot: {
    ...theme.typography.txtBody2,
    color: theme.colors.clearMain,
    marginLeft: 5
  },
  inputRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 24,
    width: 706
  },
  inputContainer: {
    width: 344
  },
  note: {
    ...theme.typography.txtBody2,
    color: theme.colors.grey3,
    marginTop: 24,
  },
  divider: {
    backgroundColor: "rgba(201, 205, 211, 0.5)"
  },
  switchBox: {
    marginTop: 30,
    marginBottom: 6,
    display: "flex",
    justifyContent: "center"
  },
  phoneLabel: {
    ...theme.typography.txtBody2,
    color: theme.colors.grey4,
    fontFamily: "Inter, sans-serif",
    display: "inline-flex",
    marginBottom: 6,
  },
  photoContainer: {
    textAlign: "center",
  },
  photo: {
    width: 120,
    height: 120,
    borderRadius: "50%",
    backgroundColor: theme.colors.grey1,
    margin: "auto",
    position: "relative",
    cursor: "pointer",
    marginBottom: 10,
    marginTop: 10,
  },
  photoIconConatiner: {
    zIndex: 2,
    position: "absolute",
    height: "100%",
    padding: 30,
  },
  photoIcon: {
    width: "70%",
    height: "100%",
    margin: "auto",
    fontSize: 70,
    color: theme.colors.grey1,
  },
  photoHover: {
    zIndex: 3,
    position: "absolute",
    width: 120,
    height: 120,
    borderRadius: "50%",
    margin: "auto",
    opacity: 0,
    background: "rgba(29, 32, 39, 0.70);",
    "&:hover": {
      opacity: 1,
      backdropFilter: "blur(5px)"
    },
  },
  cameraIcon: {
    marginTop: 40,
    color: theme.colors.white,
  },
  changePhotoLabel: {
    marginTop: 5,
    fontWeight: 700,
    fontSize: 12,
    textAlign: "center",
    color: theme.colors.white,
    opacity: 1
  },
  photoLabel: {
    ...theme.typography.txtBody3,
    color: theme.colors.grey4,
    fontWeight: 700,
    fontSize: 12,
  },
  photoSizeLabel: {
    ...theme.typography.txtBody2,
    color: theme.colors.grey4
  },
  photoInitials: {
    ...theme.typography.header1,
    color: theme.colors.clear2,
    fontWeight: 700,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 120,
    height: 120,
    border: "solid",
    borderWidth: 1,
    borderColor: theme.colors.clear2,
    borderRadius: "50%",
  },
})
);

export default useStyles;